module.exports = __webpack_public_path__ + "img/gb91-86-2.prt.0f51f79b.jpg";